import html2canvas from 'html2canvas';
export class IMG {
  static exportimagenes(grafica, name): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        var cadena = "Some description Entidad ";
        setTimeout(() => {
          const chart = document.getElementById(grafica);
          const escala = chart.offsetWidth > 800 ? 1 : 2;
          
          html2canvas(chart, {
            scale: escala,
            backgroundColor: 'white',
            logging: false,
            onclone: (document) => {
            }
          }).then((canvas) => {
            const chartData = canvas.toDataURL('image/PNG');
            var a = document.createElement('a');
            a.href = chartData;
            a.download = name + '.png';
            a.click();
            resolve();
          }).catch(error => {
            reject(error); // Maneja errores en html2canvas
          });
        }, 200);
      } catch (error) {
        reject(error);
      }
    });
  }

  static exportimagenesBlob(grafica): Promise<string> {
    return new Promise((resolve, reject) => {
      try {
        const chart = document.getElementById(grafica);

        html2canvas(chart, {
          scale: 1, // reduce tiempo
          backgroundColor: 'white',
          logging: false,
          useCORS: true, // si hay imágenes externas
        }).then((canvas) => {
          const base64 = canvas.toDataURL('image/png', 0.8); // 0.8 = comprime un poco
          resolve(base64);
        }).catch(reject);
      } catch (error) {
        reject(error);
      }
    });
  }
}